import DS, { ModelSchema } from 'ember-data';
import { ActiveModelSerializer } from 'active-model-adapter';
import { ModelRegistry } from 'ember-data/model';

const { EmbeddedRecordsMixin } = DS;

export default class SigningSecretSerializer extends ActiveModelSerializer.extend(EmbeddedRecordsMixin, {
  isNewSerializerAPI: true,
}) {
  normalize(modelClass: ModelSchema<keyof ModelRegistry>, hash: Record<string, any>, prop?: string) {
    hash.id = hash.environment_id;
    return super.normalize(modelClass, hash, prop);
  }
}
